export enum ParkingAvailabilityStatus {
	Open = 'open',
	Closed = 'closed',
	Full = 'full',
	Error = 'error',
}
